import { chart, tendermintRpc, tx } from '@/apis/http';
import { APIS, HOME, CONFIG } from '@/constants';

export default {
  async initHome({ commit, dispatch }) {
    commit('reset');
    commit('setLoading', true);
    const requests = [
      dispatch('fetchStartingDate'),
      dispatch('fetchTokensChart'),
    ];
    await Promise.all(requests);
    commit('setLoading', false);
    await dispatch('fetchTransactions');
  },

  async fetchStartingDate({ commit }) {
    try {
      const response = await tendermintRpc.requestBlock(CONFIG.FIRST_HEIGHT);
      commit('setStartingDate', response.data.block.header.time);
    } catch (error) {
      commit('setError', error);
    }
  },

  async fetchTokensChart({ commit }) {
    try {
      const response = await chart.requestTokens();
      commit('setTokensChart', response.data);
    } catch (error) {
      commit('setError', error);
    }
  },

  async fetchTransactions({ commit }) {
    commit('setLoadingTxs', true);
    try {
      const response = await tx.requestTxs(
        APIS.SORTING_ORDERS.DESC,
        HOME.TRANSACTIONS_NUMBER
      );
      commit('setTransactions', response.data.txs);
    } catch (error) {
      commit('setError', error);
    }
    commit('setLoadingTxs', false);
  },

  async refreshTransactions({ commit, dispatch }) {
    commit('setTransactions', []);
    await dispatch('fetchTransactions');
  },
};
